import { useParams, Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import { blogPosts } from '../../../mocks/blogPosts';

export default function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-black mb-4">Artigo não encontrado</h1>
          <Link to="/conteudo" className="text-gold-500 hover:underline cursor-pointer">
            Voltar para conteúdo
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-20">
        <article className="bg-white py-24">
          <div className="max-w-4xl mx-auto px-6 lg:px-12">
            <div className="mb-8">
              <Link
                to="/conteudo"
                className="inline-flex items-center text-gray-600 hover:text-black transition-colors mb-6 cursor-pointer"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                Voltar para conteúdo
              </Link>
              <div className="flex items-center space-x-4 mb-6">
                <span className="text-sm font-semibold text-gold-500 uppercase tracking-wide">
                  {post.categoria}
                </span>
                <span className="text-gray-400">•</span>
                <span className="text-sm text-gray-500">{post.tempoLeitura}</span>
                <span className="text-gray-400">•</span>
                <span className="text-sm text-gray-500">{post.data}</span>
              </div>
              <h1 className="text-5xl font-bold text-black mb-6 leading-tight">{post.titulo}</h1>
              <p className="text-xl text-gray-600 leading-relaxed">{post.resumo}</p>
            </div>

            <div className="mb-12">
              <img
                src={post.imagem}
                alt={post.titulo}
                className="w-full h-[500px] object-cover object-center rounded-2xl"
              />
            </div>

            <div className="prose prose-lg max-w-none">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Este é um artigo completo sobre {post.titulo.toLowerCase()}. O conteúdo detalhado será adicionado em breve com informações valiosas para investidores interessados no mercado imobiliário da Flórida.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                A Bravia Group está comprometida em fornecer conteúdo de qualidade que ajude investidores a tomar decisões informadas sobre seus investimentos em construção residencial na Flórida.
              </p>
            </div>

            <div className="mt-16 bg-beige-50 rounded-2xl p-10">
              <h3 className="text-2xl font-bold text-black mb-4">Quer saber mais sobre investir na Flórida?</h3>
              <p className="text-gray-700 mb-6">
                Entre em contato com nossa equipe e descubra como participar dos projetos da Bravia Group.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/investir"
                  className="px-8 py-4 bg-black text-white text-center rounded-full font-semibold hover:bg-gray-800 transition-all whitespace-nowrap"
                >
                  Ver oportunidades
                </Link>
                <a
                  href="https://wa.me/5511999999999"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 border-2 border-black text-black text-center rounded-full font-semibold hover:bg-black hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  Falar no WhatsApp
                </a>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
